goog.provide('yext.location.MapMarkerView');
goog.provide('yext.location.MarkerView');
goog.provide('yext.location.MarkerModel');
goog.provide('yext.location.GoogleMapWrapper');

goog.require('yext');
goog.require('yext.location.helpers');
goog.require('yext.notify');
goog.require('yext.storm.GoogleMapWrapper');

/**
 * TODO(mattjs): Read static image headers for bad render and provide error messaging
 */

/**
 * Paired with the MapMarkerView Java class
 *
 * @param {!jQuery} $ctx Container for all of the modules elements
 * @param {boolean} isLOG Boolean flag indicating if this is on a LOG page
 * @constructor
 * @author MattJS (matt@yext.com)
 */
yext.location.MapMarkerView = function($ctx, isLOG, data, cb, isReact) {
  this.$ctx = $ctx;
  this.isLOG = isLOG;
  this.$static = $ctx.find('.js-map-marker-static');
  this.$edit = $ctx.find('.js-map-marker-edit');
  this.$placementLayer = this.$edit.find('.js-map-marker-placement-layer');
  this.$placementLayerIcon = this.$placementLayer.find('.js-marker-icon');
  this.$geocodeWarningDialog = this.$edit.find('.js-geocode-warning-dialog');
  this.$unsavedChangesDialog = this.$edit.find('.js-map-unsaved-changes-dialog');

  this.markers = {};
  this.order = [];
  // LOG flow doesn't contain an empty map marker message
  this.hasEdit = (this.$edit.length !== 0
    && ($ctx.find('.js-map-marker-empty-message').is(':hidden') || this.isLOG))
    || isReact;
  this.data = data ? data : this.$ctx.data('field');
  this.viewOnly = this.$ctx.data('viewOnly');
  this.onChange = cb;
  this.isReact = isReact;

  if (isLOG) {
    this.$unsavedChangesDialog.find('button').hide();
    this.data.channelId = 'pyb.log.yext.com';
  }

  this.state = {
    unsavedChanges: false,
    selectedMarker: undefined,
  };

  this.moveEditToBody();
  this.initializer();
  this.binder();

  if (isReact) {
    this.showEditMode();
  }
};

yext.location.MapMarkerView.STATIC_WIDTH = 260;
yext.location.MapMarkerView.STATIC_HEIGHT = 195;
yext.location.MapMarkerView.STATIC_LOG_WIDTH = 350;
yext.location.MapMarkerView.STATIC_LOG_HEIGHT = 350;
yext.location.MapMarkerView.DEFAULT_ZOOM = 17;
yext.location.MapMarkerView.FIELD_ID = 'virtual.map_marker';

/**
 * General bindings
 * @suppress {deprecated}
 */
yext.location.MapMarkerView.prototype.binder = function() {
  var self = this;
  var $closeMapMarkerWrap = this.$edit.find('.js-close-map-marker-wrap');
  var $saveAndClose = this.$edit.find('.js-save-and-close');
  var $reset = this.$edit.find('.js-reset');

  if (this.isLOG) {
    $saveAndClose.hide();
  } else {
    $saveAndClose.click(function() {
      if (self.data.geocodeWarning) {
        self.$geocodeWarningDialog.dialog('open');
      } else {
        self.saveMap();
      }
    });
  }

  $closeMapMarkerWrap.click(function() {
    self.tryClose();
  });

  $reset.click(function() {
    self.resetData();
  });

  this.$unsavedChangesDialog.dialog({
    modal: true,
    autoOpen: false,
    draggable: false,
    resizable: false,
    minWidth: 350,
    title: yext.msg('Unsaved Changes to Map Markers'),
    closeOnEscape: false,
  });

  this.$unsavedChangesDialog.find('.js-discard').click(function() {
    self.resetData();
    self.hideEdit();
    self.$unsavedChangesDialog.dialog('close');
  });

  this.$unsavedChangesDialog.find('button').click(function() {
    self.$unsavedChangesDialog.dialog('close');
    if (self.data.geocodeWarning) {
      self.$geocodeWarningDialog.dialog('open');
    } else {
      self.saveMap();
    }
  });

  this.$geocodeWarningDialog.dialog({
    modal: true,
    autoOpen: false,
    draggable: false,
    resizable: false,
    minWidth: 350,
    title: yext.msg('Invalid address warning'),
    closeOnEscape: false,
  });

  this.$geocodeWarningDialog.find('button').click(function() {
    self.$geocodeWarningDialog.dialog('close');
    self.saveMap();
  });

  this.$placementLayer.on('mousemove', function(e) {
    if (self.state.selectedMarker && self.state.selectedMarker.isUnset()) {
      self.$placementLayerIcon.show();
      var leftOffset = Math.floor(self.$placementLayerIcon.width()/2) + 1;
      var topOffset = self.$placementLayerIcon.height() - 6;

      self.$placementLayerIcon.css({
        'left': e.clientX - leftOffset + 'px',
        'top': e.clientY - topOffset + 'px',
      });
    }
  });

  this.$placementLayer.on('click', function(e) {
    if (self.state.selectedMarker) {
      var latLng = self.getLatLngFromEvent(e);
      self.state.selectedMarker.model.updatePosition(latLng.lat(), latLng.lng());
    } else {
      self.$unsavedChangesDialog.dialog('close');
    }
  });

  $(window).on('keyup', function(e) {
    if (self.$edit.is(':visible') && e.keyCode === $.ui.keyCode.ESCAPE) {
      if (self.state.selectedMarker && self.state.selectedMarker.isUnset()) {
        self.state.selectedMarker = undefined;
        self.renderMap();
      } else {
        if (self.$unsavedChangesDialog.is(':visible')) {
          self.$unsavedChangesDialog.dialog('close');
        } else {
          self.tryClose();
        }
      }
    }
  });

  // Listen for address updated
  this.$ctx.on('locationAddressUpdated', function(e, data) {
    self.addressUpdated(data);
  });

  // Listen for address updated
  this.$ctx.on('eventLocationUpdated', function(e, data) {
    self.eventLocationUpdated(data);
  });
  this.$ctx.on('entityAddressUpdated', function(e, data) {
    self.entityAddressUpdated(data);
  });
};

/**
 * Tries to close, will show dialog when there are unsaved changes
 * @suppress {deprecated}
 */
yext.location.MapMarkerView.prototype.tryClose = function() {
  if (this.state.unsavedChanges) {
    this.$unsavedChangesDialog.dialog('open');
  } else {
    this.hideEdit();
    this.state.selectedMarker = this.markers.display;
    this.renderMap();
  }
};

/**
 * Triggered when the user changes their event location which can include an address change
 * @param {!Object} String keyed geocoded coordinate
 */
yext.location.MapMarkerView.prototype.eventLocationUpdated = function(data) {
  var $emptyMessage = this.$ctx.find('.js-map-marker-empty-message');
  var $variousMessage = this.$ctx.find('.js-map-marker-various-message');

  var hasNoLocation = Boolean(data['hasNoLocation']);
  var geocodedRoutableCoordinate = data['geocodedRoutableCoordinate'];
  var geocodedDisplayCoordinate = data['geocodedDisplayCoordinate'];

  this.viewOnly = Boolean(data['viewOnly']);

  if (hasNoLocation) {
    $variousMessage.hide();
    this.$static.hide();
    $emptyMessage.show();
  } else {
    if (data['geocodedRoutableCoordinate'] || data['geocodedDisplayCoordinate']) {
      $emptyMessage.hide();
      $variousMessage.hide();
      this.$static.show();
    }
    this.entityAddressUpdated(data);
  }
};

/**
 * Triggered when the user changes an entity's address
 * @param {!Object} String keyed geocoded coordinate
 */
yext.location.MapMarkerView.prototype.entityAddressUpdated = function(data) {
  var geocodedRoutableCoordinate = data['geocodedRoutableCoordinate'];
  var geocodedDisplayCoordinate = data['geocodedDisplayCoordinate'];
  if (geocodedRoutableCoordinate || geocodedDisplayCoordinate) {
    // Make these the same if one of them is missing
    if (!geocodedDisplayCoordinate) {
      geocodedDisplayCoordinate = geocodedRoutableCoordinate;
    }
    if (!geocodedRoutableCoordinate) {
      geocodedRoutableCoordinate = geocodedDisplayCoordinate;
    }

    var routable = {
      latitude: geocodedRoutableCoordinate['latitude'],
      longitude: geocodedRoutableCoordinate['longitude'],
      hasValidCoordinates: true,
    };
    var display = {
      latitude: geocodedDisplayCoordinate['latitude'],
      longitude: geocodedDisplayCoordinate['longitude'],
      hasValidCoordinates: true,
    };

    var clear = {
      hasValidCoordinates: false,
    };

    for (var slug in this.markers) {
      if (slug === 'display') {
        this.markers[slug].set(display);
      } else if (slug === 'routable') {
        this.markers[slug].set(routable);
      } else {
        this.markers[slug].set(clear);
      }
    }

    // NOTE(mattjs) This resolves issues with google maps rendering improperly when it does not
    // initially have any valid coordinates
    this.map = this.initializeGoogleMap(
      display.latitude,
      display.longitude);
    for (var slug in this.markers) {
      this.markers[slug].transferMaps(this.map);
    }

    this.saveState();
    this.renderStaticMap();
  }
};

/**
 * Triggered when the user changes their address which can cause geocode updates
 *
 * @param {!Object} data Details about the updates to address
 */
yext.location.MapMarkerView.prototype.addressUpdated = function(data) {
  this.$ctx.closest('.virtual-map_marker').toggle(!data.hideAddress);
  if (data.addressData) {
    this.data.geocodeWarning = data.addressData.geocodeWarning;

    var geocoded = {
      latitude: data.addressData.geocodedLat,
      longitude: data.addressData.geocodedLng,
      timestamp: data.addressData.displayTimestamp,
      hasValidCoordinates: true,
    };
    var clear = {
      timestamp: data.addressData.displayTimestamp,
      hasValidCoordinates: false,
    };

    for (var slug in this.markers) {
      if (slug === 'display' || slug === 'routable') {
        this.markers[slug].set(geocoded);
      } else {
        this.markers[slug].set(clear);
      }
    }

    this.saveState();

    this.renderStaticMap();
    if (this.hasEdit) {
      this.renderMap();
    }
  }
};

/**
 * @param {Event} e
 */
yext.location.MapMarkerView.prototype.getLatLngFromEvent = function(e) {
  var map = this.map.map_;
  var ne = map.getBounds().getNorthEast();
  var sw = map.getBounds().getSouthWest();
  var projection = map.getProjection();
  var topRight = projection.fromLatLngToPoint(ne);
  var bottomLeft = projection.fromLatLngToPoint(sw);
  var scale = 1 << map.getZoom();
  var point = new google.maps.Point(e.clientX / scale + bottomLeft.x, e.clientY / scale + topRight.y);
  var latLng = projection.fromPointToLatLng(point);
  return latLng;
};

/**
 * Restores markers to previous state and UI to default state
 */
yext.location.MapMarkerView.prototype.resetData = function() {
  this.restoreMarkers();
  this.state.unsavedChanges = false;
  this.state.selectedMarker = this.markers.display;
  if (this.isReact) {
    this.onChange(this.fetchData());
  }
  this.renderMap();
};

/**
 * Save the current state of the module
 */
yext.location.MapMarkerView.prototype.saveState = function() {
  for (var slug in this.markers) {
    this.markers[slug].saveState();
  }
};

/**
 * Restores all markers to previous state
 */
yext.location.MapMarkerView.prototype.restoreMarkers = function() {
  for (var slug in this.markers) {
    this.markers[slug].restoreState();
  }
};

/**
 * Save the markers field
 *
 * @param {!Object} data Additional data to include with the request
 */
yext.location.MapMarkerView.prototype.saveMap = function(data) {
  if (this.isReact) {
    this.onChange(this.fetchData());
    this.hideEdit();
  } else {
    var self = this;

    this.state.unsavedChanges = false;
    this.renderMap();
    this.toogleSaveFieldMessage(true);

    data = data || {};
    data['field'] = yext.location.MapMarkerView.FIELD_ID;
    data['virtual.map_marker'] = yext.JSON.stringify({
      'markers': this.fetchData(),
    });

    $.ajax({
      method: 'POST',
      data: data,
      success: function(response) {
        if (response.field) {
          for (var i = 0; i < response.field.markers.length; i++) {
            var marker = response.field.markers[i];
            self.markers[marker.slug].set(marker);
          }
        } else if (response.suggestedEditIds) {
          // Location Edit Field Flow, suggestedEdits should be handled elsewhere now
          self.resetData();
        }
        if (response.error) {
          self.showError(response.error);
          self.state.unsavedChanges = true;
          self.renderMap();
        } else if (response.field) {
          self.saveState();
          self.renderStaticMap();
          self.setMapBounds();
          if (response.stale) {
            self.showError(yext.location.helpers.staleErrorMessage);
          } else {
            self.hideEdit();
          }
        } else {
          self.resetData();
          self.hideEdit();
        }
        self.message('saved', response);
      },
      error: function() {
        self.showError(yext.msg('There was an error updating the map markers'));
      },
    }).always(function() {
      self.toogleSaveFieldMessage(false);
    });
  }
};

/**
 * @param {string} message The message to be broadcast
 * @param {!Object} data The data to send with the message
 */
yext.location.MapMarkerView.prototype.message = function(message, data) {
  $(this).trigger(message, data);
};

/**
 * Toggle message shown when the user is waiting for the save field response
 *
 * @param {boolean} show True to show the message
 */
yext.location.MapMarkerView.prototype.toogleSaveFieldMessage = function(show) {
  this.$edit.find('.js-saving-field-layer').toggle(show);
  this.map.map_.set('mapTypeControl', !show);
  this.map.map_.set('zoomControl', !show);
};

/**
 * @param {string} error Human readable error message
 * @suppress {deprecated}
 */
yext.location.MapMarkerView.prototype.showError = function(error) {
  yext.notify.showError(error);
};

/**
 * @param {!jQuery} $target Binds target to launch edit mode
 */
yext.location.MapMarkerView.prototype.bindEditTarget = function($target) {
  var self = this;

  $target.click(function(e) {
    e.stopPropagation(); // This is important, combats a trigger from LocationEdit.js
    self.showEditMode();
  });
};

/**
 * Show the edit map marker panel
 */
yext.location.MapMarkerView.prototype.showEditMode = function() {
  if (this.viewOnly) {
    return;
  }

  var self = this;
  this.$edit.show().css({
    'visibility': 'visible',
    'z-index': 1000,
  });
  setTimeout(function() {
    self.$edit.addClass('fully-opaque');
  }, 0);
  $('body').addClass('no-scroll');
  if (this.map) {
    // Clears up some issues with the map being hidden
    this.setMapBounds();
  }
};

/**
 * Hide the edit map marker panel
 */
yext.location.MapMarkerView.prototype.hideEdit = function() {
  this.setMapBounds();
  this.$edit.hide().removeClass('fully-opaque');
  $('body').removeClass('no-scroll');
};

/**
 * Get models and kick off the rest of initialization
 */
yext.location.MapMarkerView.prototype.initializer = function() {
  var self = this;
  var models = {};

  this.data['markers'].forEach(function(marker) {
    var model = new yext.location.MarkerModel(marker);
    models[model.slug] = model;
    self.order.push(model.slug);
  });

  if (models.display.hasValidCoordinates) {
    this._initialize(models);
  } else if (this.hasAddress()) {
    this.tryToGeocodeAddress(function(latitude, longitude) {
      models.display.latitude = latitude;
      models.display.longitude = longitude;
      self._initialize(models);
    }, function() {
      self.errorInitializing();
    });
  } else {
    // Initialize anyways, no valid markers
    this._initialize(models);
  }
};

/**
 * @param {!Object} models Map marker models by slug
 */
yext.location.MapMarkerView.prototype._initialize = function(models) {
  var menuItems = {};

  if (this.hasEdit) {
    // Get menu items
    this.$edit.find('.js-marker-list li').each(function() {
      var $menuItem = $(this);
      menuItems[$menuItem.data('slug')] = $menuItem;
    });

    // Put the map on screen, hidden, for proper render
    this.$edit.show().css({
      'visibility': 'hidden',
      'z-index': -1,
    });

    this.map = this.initializeGoogleMap(
      models.display.latitude,
      models.display.longitude);
  }

  // Build views
  for (var slug in models) {
    var marker = new yext.location.MarkerView(models[slug], menuItems[slug], this.map);
    this.bindMarker(marker);
    this.markers[slug] = marker;
  }

  this.renderStaticMap();

  if (this.hasEdit) {
    this.state.selectedMarker = this.markers.display;
    this.renderMap();
    this.setMapBounds();
  }
};

/**
 * @param {number} latitude
 * @param {number} longitude
 * @return {yext.location.GoogleMapWrapper}
 */
yext.location.MapMarkerView.prototype.initializeGoogleMap = function(latitude, longitude) {
  return new yext.location.GoogleMapWrapper(
    this.$edit.find('.js-map-target')[0],
    latitude,
    longitude);
};

/**
 * Sets the maps bounds to fit all markers, with a maximum zoom level
 */
yext.location.MapMarkerView.prototype.setMapBounds = function() {
  var bounds = new google.maps.LatLngBounds();
  var map = this.map.map_;
  var containsAll = true;

  google.maps.event.trigger(map, 'resize');
  var center = new google.maps.LatLng({lat: 40.740989, lng: -73.989324});
  if (this.markers.display) {
    var display = new google.maps.LatLng({
      lat: this.markers.display.model.latitude,
      lng: this.markers.display.model.longitude,
    });
    if (!isNaN(display.lat()) && !isNaN(display.lng())) {
      center = display;
    }
  }

  map.setCenter(center);
  map.setZoom(yext.location.MapMarkerView.DEFAULT_ZOOM);

  if (!map.getBounds()) {
    return;
  }

  for (var slug in this.markers) {
    if (!this.markers[slug].isUnset()) {
      var marker = this.markers[slug].googleMarker;
      bounds.extend(marker.getPosition());
      containsAll &= map.getBounds().contains(marker.getPosition());
    }
  }

  if (!containsAll) { // Only rebound if needed
    map.setOptions({maxZoom: yext.location.MapMarkerView.DEFAULT_ZOOM}); // Keeps it from zooming too far in
    map.fitBounds(bounds);
    map.setOptions({maxZoom: null}); // Remove the restriction
    map.setZoom(map.getZoom() - 2); // Zoom out because of menu
  }
};

/**
 * Returns the display map marker position if set and valid, or else Yext HQ
 *
 * @return {google.maps.LatLng} A place to center the map
 */
yext.location.MapMarkerView.prototype.fetchCenter = function() {
  var center = new google.maps.LatLng({lat: 40.740989, lng: -73.989324});
  if (this.markers.display) {
    var display = new google.maps.LatLng({
      lat: this.markers.display.model.latitude,
      lng: this.markers.display.model.longitude,
    });
    if (!isNaN(display.lat()) && !isNaN(display.lng())) {
      center = display;
    }
  }
  return center;
};

/**
 * Bind updates from markers and the marker menu item
 *
 * @param {yext.location.MarkerView} marker The marker being bound
 */
yext.location.MapMarkerView.prototype.bindMarker = function(marker) {
  var self = this;

  $(marker).on('selected', function() {
    if (self.state.selectedMarker != marker) {
      self.state.selectedMarker = marker;
      self.renderMap();
    }
  });

  $(marker).on('updated', function() {
    self.state.unsavedChanges = true;
    self.renderMap();
  });
};

/**
 * This block handles syncing the UI with the values stored in the state object
 */
yext.location.MapMarkerView.prototype.renderMap = function() {
  this.$edit.find('.js-save-and-close').prop('disabled', !this.state.unsavedChanges);
  this.$edit.find('.js-reset').toggle(this.state.unsavedChanges);
  if (this.state.selectedMarker) {
    var marker = this.state.selectedMarker;

    this.$placementLayer.toggle(marker.isUnset());
    if (marker.isUnset()) {
      this.$placementLayerIcon.find('.js-marker-icon-image').empty().append(marker.icon);
      this.$placementLayerIcon.hide();
    }
    this.map.map_.set('mapTypeControl', !marker.isUnset());
    this.map.map_.set('zoomControl', !marker.isUnset());

    if (!marker.$menu.hasClass('selected')) {
      this.deselectMarkers();
      marker.selectMarker();
    }
  } else {
    this.map.map_.set('mapTypeControl', true);
    this.map.map_.set('zoomControl', true);
    this.$placementLayer.hide();
    this.deselectMarkers();
  }
};

/**
 * Deselect all map markers
 */
yext.location.MapMarkerView.prototype.deselectMarkers = function() {
  for (var slug in this.markers) {
    this.markers[slug].deselectMarker();
  }
};

/**
 * Pull the edit panel out and into the body of the page
 */
yext.location.MapMarkerView.prototype.moveEditToBody = function() {
  this.$edit.remove();
  $('body').append(this.$edit);
};

/**
 * Check the display coordinates and if neededgeocode using the address
 * and the MapQuest API
 *
 * @param {function()} success
 * @param {function()} error
 */
yext.location.MapMarkerView.prototype.tryToGeocodeAddress = function(success, error) {
  this.requestGeocodeFromBadAddress(function(latitude, longitude) {
    if (typeof latitude === 'undefined') {
      error();
    } else {
      success(latitude, longitude);
    }
  });
};

/**
 * @return {boolean} True if the address object looks well formed
 */
yext.location.MapMarkerView.prototype.hasAddress = function() {
  if (typeof this.data.address == 'object' && !!this.data.address) {
    return (this.data.address.city || this.data.address.postalCode) && this.data.address.country;
  }
  return false;
};

/**
 * Ask MapQuest to geocode an address
 *
 * @param {function()} cb Callback after ajax call to MapQuest
 */
yext.location.MapMarkerView.prototype.requestGeocodeFromBadAddress = function(cb) {
  var self = this;
  $.ajax({
    url: '//www.mapquestapi.com/geocoding/v1/address?key=Gmjtd|luu7nuu1n0,rw|o5-ly10q',
    type: 'POST',
    data: window.JSON.stringify({'location': this.data.address}),
    contentType: 'application/json',
  }).done(function(data) {
    if (data.results.length > 0
        && data.results[0].locations.length > 0
        && data.results[0].locations[0].latLng != null) {
      var latitude = data.results[0].locations[0].latLng.lat;
      var longitude = data.results[0].locations[0].latLng.lng;
      cb(latitude, longitude);
    } else {
      cb();
    }
  });
};

/**
 * Show a toast when the map marker has problems initializing
 * TODO(mattjs) The static map area should be updated when there is an error
 * @suppress {deprecated}
 */
yext.location.MapMarkerView.prototype.errorInitializing = function() {
  yext.notify.showError(yext.msg('There was an error initializing the Map Marker'));
};

/**
 * Render the static map
 */
yext.location.MapMarkerView.prototype.renderStaticMap = function() {
  if (!this.$static.length) {
    return;
  }

  var self = this;
  var path = this.fetchBasicResourcePath();

  for (var i = 0; i < this.order.length; i++) {
    var marker = this.markers[this.order[i]];
    if (marker.model.hasValidCoordinates) {
      path += marker.getResourcePathFragment();
    }
  }

  this.safeSignResource(path, function(url) {
    var image = new Image();
    image.onload = function() {
      self.$static.addClass('hide-map');
      self.$static.append(image);
      setTimeout(function() {
        self.$static.removeClass('hide-map');
      }, 0);
    };
    image.src = url;
  });
};

/**
 * Sign the static map resource
 *
 * @param {string} path The resource path for the static map
 * @param {function()} cb Callback after the resource is signed
 */
yext.location.MapMarkerView.prototype.safeSignResource = function(path, cb) {
  var self = this;
  $.get('/s/' + yext.businessId + '/profile/safeSignGoogleMapsRequest?resource=' + encodeURIComponent(path))
    .then(function(signedResourcePath) {
      cb('//maps.googleapis.com' + path + signedResourcePath + '&channel=' + encodeURIComponent(self.data.channelId));
    });
};

/**
 * @return {string} Generate the basic resource path for a static map
 */
yext.location.MapMarkerView.prototype.fetchBasicResourcePath = function() {
  var center = this.fetchCenter();
  return '/maps/api/staticmap?size=' +
    (this.isLOG ? yext.location.MapMarkerView.STATIC_LOG_WIDTH : yext.location.MapMarkerView.STATIC_WIDTH) + 'x' +
    (this.isLOG ? yext.location.MapMarkerView.STATIC_LOG_HEIGHT : yext.location.MapMarkerView.STATIC_HEIGHT) +
    '&zoom=' + yext.location.MapMarkerView.DEFAULT_ZOOM + '&center=' + center.lat() + ',' + center.lng();
};

/**
 * @return {!Array} List of markers
 */
yext.location.MapMarkerView.prototype.fetchData = function() {
  var markers = [];
  for (var slug in this.markers) {
    markers.push(this.markers[slug].model.get());
  }
  return markers;
};

/**
 * Single marker model
 *
 * @constructor
 */
yext.location.MarkerModel = function(data) {
  this.fieldId = data.fieldId;
  this.latitude = data.latitude;
  this.longitude = data.longitude;
  this.slug = data.slug;
  // This will determine 'set' vs geocoded defaults
  this.hasValidCoordinates = data.hasValidCoordinates;
  this.timestamp = data.timestamp;
};

/**
 * @param {number} latitude
 * @param {number} longitude
 */
yext.location.MarkerModel.prototype.updatePosition = function(latitude, longitude) {
  if (typeof latitude !== 'number' || typeof longitude !== 'number') {
    throw new TypeError('Marker positions must be numbers');
  }
  var changed = this.latitude !== latitude || this.longitude !== longitude;
  this.latitude = latitude;
  this.longitude = longitude;
  this.hasValidCoordinates = true;

  if (changed) {
    this.message('updated');
  }
};

/**
 * Trigger a message with the marker instance as context
 *
 * @param {string} message
 */
yext.location.MarkerModel.prototype.message = function(message) {
  $(this).trigger(message);
};

/**
 * @return {!Object} Plain version of this model keyed with strings
 */
yext.location.MarkerModel.prototype.get = function() {
  return {
    'fieldId': this.fieldId,
    'latitude': this.latitude,
    'longitude': this.longitude,
    'timestamp': this.timestamp,
    'hasValidCoordinates': this.hasValidCoordinates,
  };
};

/**
 * Single marker view
 *
 * @param {yext.location.MarkerModel} model
 * @param {!jQuery} $menu
 * @param {google.maps.Map} map
 * @constructor
 */
yext.location.MarkerView = function(model, $menu, map) {
  this.model = model;
  this.$menu = $menu || $();
  this.$menuContent = this.$menu.find('.js-content-wrap');
  this.icon = new Image();
  this.icon.src = this.getLocalMarkerIconUrl();

  if (map) {
    this.saveState();
    this.setup(map);
    this.bind();
    this.renderMarker();
  }
};

/**
 * Setup the Google Map marker
 *
 * @param {yext.location.GoogleMapWrapper} map Map wrapper
 */
yext.location.MarkerView.prototype.setup = function(map) {
  if (this.model.hasValidCoordinates) {
    this.createGoogleMarker(map);
  } else {
    this.createHiddenGoogleMarker(map);
  }
};

/**
 * When one map fails, use another!
 * @param {yext.location.GoogleMapWrapper} map
 */
yext.location.MarkerView.prototype.transferMaps = function(map) {
  this.setup(map);
  this.bindGoogleMarker();
};

/**
 * Bind the model and the menu
 */
yext.location.MarkerView.prototype.bind = function() {
  var self = this;
  $(this.model).on('updated', function() {
    self.renderMarker();
    self.message('updated');
  });

  this.$menu.click(function() {
    self.message('selected');
  });

  this.bindGoogleMarker();
};

/**
 * Render the field including the map marker placement
 */
yext.location.MarkerView.prototype.renderMarker = function() {
  this.$menu.find('.js-marker-set-icon').toggle(!this.isUnset());

  if (this.isUnset()) {
    this.googleMarker.setVisible(false);
  } else {
    this.googleMarker.setPosition({
      lat: this.model.latitude,
      lng: this.model.longitude,
    });
    this.googleMarker.setVisible();
  }
};

/**
 * Check if the field has a value
 *
 * @return {boolean} True if the field has no value
 */
yext.location.MarkerView.prototype.isUnset = function() {
  return typeof this.model.latitude !== 'number' || typeof this.model.longitude !== 'number';
};

/**
 * @return {string} The remote url for the map marker icon
 */
yext.location.MarkerView.prototype.getMarkerIconUrl = function() {
  return 'http://a.mktgcdn.com/mapmarker/' + this.model.slug + '-large-pin.png';
};

/**
 * @return {string} The `local` url for the map marker icon
 */
yext.location.MarkerView.prototype.getLocalMarkerIconUrl = function() {
  return '/s/public/images/map-marker-icons/' + this.model.slug + '-large-pin.png';
};

/**
 * @return {string} The resource path fragment for this marker
 */
yext.location.MarkerView.prototype.getResourcePathFragment = function() {
  return '&markers=icon:' + encodeURIComponent(this.getMarkerIconUrl()) +
    '%7C' + this.model.latitude + ',' + this.model.longitude;
};

/**
 * Create Google Map marker
 *
 * @param {yext.location.GoogleMapWrapper} map Wrapper of Google Maps JS API
 */
yext.location.MarkerView.prototype.createGoogleMarker = function(map) {
  var self = this;

  this.googleMarker = map.createMarker(
    this.model.latitude,
    this.model.longitude,
    this.getLocalMarkerIconUrl());

  this.googleMarker.addListener('mousedown', function() {
    self.message('selected');
  });

  this.googleMarker.addListener('dragend', function(e) {
    self.model.updatePosition(e.latLng.lat(), e.latLng.lng());
  });
};

/**
 * Create Google Map marker with the model lat/lng
 *
 * @param {yext.location.GoogleMapWrapper} map Wrapper of Google Maps JS API
 */
yext.location.MarkerView.prototype.createGoogleMarker = function(map) {
  this.googleMarker = map.createMarker(
    this.model.latitude,
    this.model.longitude,
    this.getLocalMarkerIconUrl());
};

/**
 * Create Google Maps marker and place it in the center of the map
 *
 * @param {yext.location.GoogleMapWrapper} map Wrapper of Google Maps JS API
 */
yext.location.MarkerView.prototype.createHiddenGoogleMarker = function(map) {
  var center = map.map_.getCenter();
  this.googleMarker = map.createMarker(
    center.lat(),
    center.lng(),
    this.getLocalMarkerIconUrl());

  this.googleMarker.setVisible(false);
};

/**
 * Listen for updates from the Google Maps marker
 */
yext.location.MarkerView.prototype.bindGoogleMarker = function() {
  var self = this;

  this.googleMarker.addListener('mousedown', function() {
    self.message('selected');
  });

  this.googleMarker.addListener('dragend', function(e) {
    self.model.updatePosition(e.latLng.lat(), e.latLng.lng());
  });
};

/**
 * Trigger a message with the marker instance as context
 *
 * @param {string} message
 */
yext.location.MarkerView.prototype.message = function(message) {
  $(this).trigger(message);
};

/**
 * Deselect the Google Maps marker if there is one and deselect the menu
 */
yext.location.MarkerView.prototype.deselectMarker = function() {
  var self = this;

  this.googleMarker.setOpacity(0.5);
  this.googleMarker.setZIndex(undefined); // Standard z-index

  if (this.isUnset()) {
    this.googleMarker.setVisible(false);
  }

  this.$menu.removeClass('selected');
  if (this.$menuContent.is(':visible')) {
    setTimeout(function() {
      self.$menuContent.css('height', 0);
    }, 0);
  } else {
    self.$menuContent.css('height', 0);
  }
};

/**
 * Select the Google Maps marker if there is one and select the menu item
 */
yext.location.MarkerView.prototype.selectMarker = function() {
  var self = this;
  var height = this.getTargetMenuHeight();

  this.googleMarker.setOpacity(1);
  this.googleMarker.setZIndex(google.maps.Marker.MAX_ZINDEX + 1);

  this.$menu.addClass('selected');
  if (this.$menuContent.is(':visible')) {
    setTimeout(function() {
      self.$menuContent.css('height', height);
    }, 0);
  } else {
    this.$menuContent.css('height', 'auto');
  }
};

/**
 * Show then hide them menu item so capture the target height of the element
 *
 * @return {number} Target height of menu item
 */
yext.location.MarkerView.prototype.getTargetMenuHeight = function() {
  this.$menuContent.css('height', 'auto');
  var height = this.$menuContent.height();
  this.$menuContent.css('height', 0);
  return height;
};

/**
 * Save the state of the model
 */
yext.location.MarkerView.prototype.saveState = function() {
  this.savedState = this.model.get();
};

/**
 * Restore the state of the model to the saved state
 */
yext.location.MarkerView.prototype.restoreState = function() {
  this.set(this.savedState);
};

/**
 * Make an update to the marker model and render
 *
 * @param {!Object} model Object literal for yext.location.MarkerModel
 */
yext.location.MarkerView.prototype.set = function(model) {
  this.model.latitude = model.latitude;
  this.model.longitude = model.longitude;
  this.model.hasValidCoordinates = model.hasValidCoordinates;
  if (model.timestamp) {
    this.model.timestamp = model.timestamp;
  }
  if (this.googleMarker) {
    this.renderMarker();
  }
};

/**
 * Extends yext.storm.GoogleMapWrapper to override the constructor
 *
 * @param {HTMLElement} container The map bounding container
 * @param {number} latitude
 * @param {number} longitude
 * @constructor
 */
yext.location.GoogleMapWrapper = function(container, latitude, longitude) {
  this.center_ = new google.maps.LatLng(latitude, longitude);
  this.zoom_ = yext.location.MapMarkerView.DEFAULT_ZOOM;

  var mapOptions = {
    center: this.center_,
    zoom: this.zoom_,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    mapTypeControlOptions: {
      position: google.maps.ControlPosition.TOP_CENTER,
    },
    zoomControl: true,
    zoomControlOptions: {
      style: google.maps.ZoomControlStyle.LARGE,
      position: google.maps.ControlPosition.RIGHT_BOTTOM,
    },
    panControl: true,
    panControlOptions: {
      position: google.maps.ControlPosition.RIGHT_BOTTOM,
    },
    scaleControl: true,
    streetViewControl: false,
    mapTypeControl: true,
    fullscreenControl: false,
    scrollwheel: true,
    styles: [
      {
        'featureType': 'poi',
        'stylers': [
          {
            'visibility': 'on',
          },
        ],
      },
      {
        'featureType': 'poi.business',
        'stylers': [
          {
            'visibility': 'on',
          },
        ],
      },
    ],
  };

  // google.maps.Map for displaying customer location
  this.map_ = new google.maps.Map(container, mapOptions);
};
goog.inherits(yext.location.GoogleMapWrapper, yext.storm.GoogleMapWrapper);
